const Progress = ({ title, value, max, color = 'rgb(0, 107, 0)' }) => {
  console.log('Progress bar color:', color);
  return (
    <div className="w-full max-w-[200px] m-w-[120px]">
      <div className="relative h-3 rounded-full bg-gray-300">
        <div
          className="h-full transition-width ease-in-out duration-300 rounded-full"
          style={{
            width: `${(value / max) * 100}%`,
            maxWidth: `${max * 10 + (100 - max * 10)}%`,
            backgroundColor: color,
          }}
        ></div>
      </div>
      <span className="font-bold text-sm md:text-lg">{title}</span>
    </div>
  );
};
export default Progress;
